var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { "background-color": "#cccccc" } }, [
    _c("h3", { staticClass: "text-center bold" }, [
      _vm._v("\n    " + _vm._s(_vm.title) + "\n  "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }